export default __webpack_public_path__ + "static/media/OfflineIcon.78c18eaa.svg";